<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import AddressCard from "../Address/AddressCard.svelte";
  import UserCard from "../User/UserCard.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import Map from "../Map.svelte";
  import { selectedAddressStore } from "../../lib/stores/addresses";
  import { onDestroy, onMount } from "svelte";
  import { startDeliveryProgressTracker, stopDeliveryProgressTracker } from "../../lib/helpers/steps/progress";
  import type { OrderEvent } from "../../types/orderEvent";
  import GiftDeliveryInfo from "../Progress/GiftDeliveryInfo.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import Typography from "../Typography.svelte";
  import type { LatLngLiteral } from "../../types/map";
  import { type ProgressWSInterface } from "../../lib/ws/progressWSInterface";
  import Pill from "../Pill.svelte";
  import { sessionStore } from "../../lib/stores/session";
  import CustomHtml from "../CustomHTML.svelte";
  import Youtube from "../Youtube.svelte";

  export let currentRoute;
  let progressLocations: { icon: string, coords: LatLngLiteral }[] = [];
  let orderEvent: OrderEvent;
  let progressTracker: ProgressWSInterface;

  const onDeliveryProgressUpdate = (
    event: OrderEvent,
    currentLocations: { icon: string, coords: LatLngLiteral }[]
  ) => {
    progressLocations = currentLocations;
    orderEvent = event;
  };

  onMount(async () => {
    progressTracker = await startDeliveryProgressTracker(onDeliveryProgressUpdate);
  });

  onDestroy(() => {
    stopDeliveryProgressTracker(progressTracker);
  });

  $: copy = $getCopy("progress") as Record<string, string>;
  $: progressLocations && orderEvent;
  $: selectedGift = $sessionStore.gift;
  $: selectedAddress = $selectedAddressStore!;
</script>

<BaseStep {currentRoute} hideMobileArtwork={true} showBackButton={false}>
  <svelte:fragment slot="content">
    <div class="w-full flex flex-col gap-4 lg:gap-8">
      <div class="w-full mx-auto text-center lg:text-left mb-10">
        <SharedHeading headerCopy={copy.headerCopy} />
      </div>

      {#if selectedGift && selectedGift?.image}
        <div class="flex flex-row gap-4 max-h-20">
          <div
            class="bg-cover bg-center rounded-lg block h-20 w-20"
            role="img"
            aria-label={selectedGift?.image}
            style={`background-image: url("${selectedGift?.image}");`}>
          </div>
          <div class="flex flex-col gap-3 justify-center">
            <Typography mobile={TypographyType.Body1Medium} desktop={TypographyType.Headline5Medium}>
              {selectedGift?.visible_name || selectedGift?.name}
            </Typography>
            <Pill text={selectedGift?.variation} />
          </div>
        </div>
      {/if}

      <!-- Gift Tracking component with gift details and progress -->
      <GiftDeliveryInfo latestTrackingEvent={orderEvent} />

      <!-- Map section -->
      <div class="lg:hidden my-4">
        <Map isMobile={true} progressLocations={progressLocations} />
      </div>

      <!-- Order details section -->
      <div>
        <div class="mb-4">
          <Typography mobile={TypographyType.Headline3} desktop={TypographyType.Headline1} copy={copy.orderDetailsCopy} />
        </div>
        <UserCard hideEditButton={true} />
        <AddressCard {selectedAddress} hideEditButton={true} />
      </div>

      <CustomHtml customHtml={copy.customHtml} />
      <Youtube videoId={copy.videoId} />
    </div>
  </svelte:fragment>
  <svelte:fragment slot="artwork">
    <Map progressLocations={progressLocations} />
  </svelte:fragment>
</BaseStep>

<style>
</style>
